var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThankYouConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 518,
    height: 235,
    viewBox: "0 0 518 235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1412",
    "data-name": "Rectangle 1412",
    width: 518,
    height: 235
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1._LogIn_3",
    "data-name": "1. LogIn \\u2013 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8569",
    "data-name": "Group 8569",
    transform: "translate(-705 -86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M2600.412,398.111l-3.208,3.121-5.592-4.608-5.253,3.984-4.749-2.764-1.4,2.4,6.351,3.7,4.979-3.776,5.816,4.793,4.828-4.7Z",
    transform: "translate(-72.361 -2309.824) rotate(60)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M2215.973,280.657l-4.741-1.083.9-7.821-6.738-2.438-.283-5.963-3.019.144.379,7.975,6.385,2.31-.936,8.136,7.135,1.629Z",
    transform: "translate(-882.15 1130.285) rotate(-30)",
    fill: "rgba(240,154,10,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M1456.261,222.307l-5.13,1.7-3.638-7.953-7.806,1.553-3.7-5.507-2.788,1.871,4.943,7.365,7.4-1.471,3.785,8.274,7.72-2.55Z",
    transform: "translate(522.526 1531.098) rotate(-79)",
    fill: "rgba(240,154,10,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    d: "M1456.261,222.307l-5.13,1.7-3.638-7.953-7.806,1.553-3.7-5.507-2.788,1.871,4.943,7.365,7.4-1.471,3.785,8.274,7.72-2.55Z",
    transform: "translate(-678.065 -73.789) rotate(1)",
    fill: "#dc083a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M931.127,324.845l-5.643.226-2.22,5.314-6.343-.2-.62,6.389-7.183.1-1.3,5.813-6.9,1.222-.463-2.61,5.156-.914,1.367-6.134,6.9-.092.63-6.5,7,.215,2.168-5.189,5.23-.209.711-3.706,2.6.5Z",
    transform: "translate(-157.175 -71.031)",
    fill: "rgba(240,154,10,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M1835.117,268l-2.178,5.436L1823.8,270.9l-4.165,7.555-7.146-.782-.4,3.617,9.557,1.047,3.947-7.16,9.5,2.641,3.277-8.18Z",
    transform: "translate(-691.332 320.174) rotate(-13)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M1986.545,250.444a3.277,3.277,0,1,1-3.277-3.277,3.277,3.277,0,0,1,3.277,3.277Z",
    transform: "translate(-888.88 -70.705)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M2585.686,266.091a2.738,2.738,0,1,1-2.738-2.738A2.738,2.738,0,0,1,2585.686,266.091Z",
    transform: "translate(-1637.469 -75.723)",
    fill: "#dc083a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M2111.607,344.232a2.787,2.787,0,1,1-2.788-2.787A2.787,2.787,0,0,1,2111.607,344.232Z",
    transform: "translate(-949.44 -114.863)",
    fill: "#dc083a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M503.5,405.041a3.091,3.091,0,1,1-3.091-3.091A3.091,3.091,0,0,1,503.5,405.041Z",
    transform: "translate(322.349 -230.438)",
    fill: "#5066e7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouConfetti);
export default __webpack_public_path__ + "static/media/thank-you-confetti.77333f336be5205512185593764dee3a.svg";
export { ForwardRef as ReactComponent };